// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { RejectedTransfer } from '@daml.js/dtc-registry/lib/Dtc/Registry/V3/Holding/Transfer';
import { TemplateHistory, useTemplateHistory } from '../../useTemplateHistory';

export const useRejectedTransfers = (): TemplateHistory<RejectedTransfer> =>
  useTemplateHistory(RejectedTransfer);
